import { render, staticRenderFns } from "./plenigo-auth-v2.vue?vue&type=template&id=17b79760&"
import script from "./plenigo-auth-v2.vue?vue&type=script&lang=js&"
export * from "./plenigo-auth-v2.vue?vue&type=script&lang=js&"
import style0 from "./plenigo-auth-v2.vue?vue&type=style&index=0&id=17b79760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports